import React, { useEffect } from "react";
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';

import Form from "../../components/Form";
import Input from '../../components/Form/Input';
import Container from '../../components/Container/Container';

import styles from './Login.module.scss';
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Page from "../../components/Page";

const Login = () => {
    const form = Form.useForm();
    const navigate = useNavigate();
    const {user, setUser} = useAuth();

    const handleLogin = async (data) => {
        const userCredential = await signInWithEmailAndPassword(auth, process.env.REACT_APP_EMAIL, data.password);

        const user = userCredential.user;
        setUser(user);
    }

    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate])

    return (
        <Page title="Камена & Христо ♥ Вход">
            <Container className={styles.container}>
                <h2>Добре дошли!</h2>
                <p>За да продължиш напред трябва да въведеш паролата, която се намира от задната страна на поканата.</p>
                <Form form={form} onSubmit={handleLogin}>
                    <Input name="password" label="Въведи паролата от поканата" />
                </Form>
            </Container>
        </Page>
    );
}

export default Login;